import { useState } from 'react'

import { Tooltip } from 'components'

import * as S from './styles'

export interface CopyButtonProps {
  text: string
}

export const CopyButton: React.FC<CopyButtonProps> = ({ text }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <Tooltip arrow placement="top" title={copied ? 'Copiado!' : 'Copiar'}>
      <S.CopyButton id="btn-copy" onClick={handleCopy}>
        <S.DoneIcon copied={copied} />
        <S.CopyIcon copied={copied} />
      </S.CopyButton>
    </Tooltip>
  )
}
